<script lang="ts">
    import { theme } from '$theme/theme.svelte';
    import CompanieLogos from './companie-logos.svelte';

    export let backgroundColor = 'transparent';
    export let fill: string = $theme.colors.primary[800];
</script>

<section style:background-color={backgroundColor}>
    <CompanieLogos {fill} />
    <CompanieLogos {fill} />
    <CompanieLogos {fill} />
</section>

<style>
    section {
        width: 100%;
        max-width: 100vw;
        padding-top: var(--spacing-20);
        padding-bottom: var(--spacing-20);
        background-color: var(--colors-primary-900);

        display: flex;
        justify-content: flex-start;
        align-items: center;

        overflow: hidden;
        white-space: nowrap;
    }
</style>
